/** @jsxImportSource @emotion/react */
import React from "react";
import {css} from "@emotion/react";
import styled from "@emotion/styled";
import {appLink} from "@rw/cars_routes";
import {carsTheme} from "@rw/themes";

import logo from "../../assets/logo-white.webp";
import {PageContainer} from "../app/atoms/PageContainer";
import {getOfferListUrl} from "../offer/list/url_utils/get_offer_list_url";

const FooterContainer = styled.footer`
    background-color: ${carsTheme.colors.gray};
    padding: 20px 20px 40px 20px;
    color: ${carsTheme.colors.text_white};
`;
const FooterColumnContainer = styled.div`
    background-color: ${carsTheme.colors.gray};
    display: flex;
    justify-content: space-between;
    flex-wrap: wrap;
    color: ${carsTheme.colors.text_white};
`;

const FooterColumn = styled.div`
    flex: 1;
    min-width: 150px;
    margin: 10px 0;

    h4 {
        margin-bottom: 10px;
        font-size: 16px;
        color: ${carsTheme.colors.text_white};
    }

    ul {
        list-style: none;
        padding: 0;
        margin: 0;
    }

    li {
        margin-bottom: 8px;
    }

    a {
        text-decoration: none;
        color: ${carsTheme.colors.text_white};

        &:hover {
            text-decoration: underline;
        }
    }
`;

const browseLinks = [
    {name: "Wszystkie oferty", url: getOfferListUrl({offerType: "osobowe"})},
    {name: "Aktualności", url: appLink.news()},
    {name: "Ulubione", url: appLink.favourites()}
];

const servicesLinks = [
    {name: "Kup samochód", url: getOfferListUrl({offerType: "osobowe"})},
    {name: "Sprzedaj samochód", url: appLink.admin.login},
    {name: "Dodaj ofertę za darmo", url: appLink.admin.login}
];

const supportLinks = [{name: "Kontakt", url: appLink.contactUs()}];

const socialLinks = [{name: "Facebook", url: "https://www.facebook.com/profile.php?id=61570094337466", target: "_blank" as const}];

export const Footer: React.FC = () => {
    return (
        <FooterContainer>
            <PageContainer>
                <div css={footerLogo}>
                    <img src={logo} alt="zakupauto.pl" width={146} height={40} />
                </div>
                <FooterColumnContainer>
                    <FooterColumn>
                        <h4>Przeglądaj</h4>
                        <ul>
                            {browseLinks.map((link) => (
                                <li key={link.name}>
                                    <a href={link.url}>{link.name}</a>
                                </li>
                            ))}
                        </ul>
                    </FooterColumn>
                    <FooterColumn>
                        <h4>Usługi</h4>
                        <ul>
                            {servicesLinks.map((link) => (
                                <li key={link.name}>
                                    <a href={link.url}>{link.name}</a>
                                </li>
                            ))}
                        </ul>
                    </FooterColumn>
                    <FooterColumn>
                        <h4>Wsparcie</h4>
                        <ul>
                            {supportLinks.map((link) => (
                                <li key={link.name}>
                                    <a href={link.url}>{link.name}</a>
                                </li>
                            ))}
                        </ul>
                    </FooterColumn>
                    <FooterColumn>
                        <h4>Social Media</h4>
                        <ul>
                            {socialLinks.map((link) => (
                                <li key={link.name}>
                                    <a href={link.url} {...(link.target ? {target: link.target, rel: "noopener noreferrer"} : {})}>
                                        {link.name}
                                    </a>
                                </li>
                            ))}
                        </ul>
                    </FooterColumn>
                </FooterColumnContainer>
            </PageContainer>
        </FooterContainer>
    );
};

const footerLogo = css`
    padding: 25px 0 10px 0;
`;
